import React, { useState } from 'react';
import { commentHelper } from '../../../../../_helpers/commentHelper';

const SORT_TYPES = {
    DEFAULT: 'default',
    POSITIONAL: 'positional'
};

const CommentSorter = (props) => {
    const [selectedSort, setSelectedSort] = useState(SORT_TYPES.DEFAULT);
    const positionalSelected = selectedSort === SORT_TYPES.POSITIONAL;
    const selectedSortLabel = positionalSelected ? 'Positional' : 'Default';
    const primaryColor = 'var(--primary-color)';

    const getOptionStyle = (sortType) => ({
        color: selectedSort === sortType ? primaryColor : 'inherit',
        fontWeight: selectedSort === sortType ? 600 : 400
    });
    
    const onSortComments = () => {
        props.releaseCommentSelection();        
    }

    const sortPositional = () => {
        onSortComments();
        var result = commentHelper.sortPositionally([...props.annotationComments], {
            pageCount: props.pageCount,
            isVideo: props.isVideoContext === true
        });
        props.setAnnotationComments(result);
        setSelectedSort(SORT_TYPES.POSITIONAL);
    }

    const sortDefault = () =>  {
        onSortComments();
        var result = commentHelper.sortByTime([...props.annotationComments] );        
        props.setAnnotationComments(result); 
        setSelectedSort(SORT_TYPES.DEFAULT);
    }
    
    return (
        <div
            className="mrnda-tabs-themed__item--active__tools"
            title={`Sort comments (${selectedSortLabel})`}>
            <div className="dropdown">
                <span
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{
                        color: positionalSelected ? primaryColor : 'inherit'
                    }}
                    className="threedots__label">
                    {/* <i className="fas fa-sort"></i> */}
                    <i className="fas fa-arrows-alt-v"></i>
                </span>
                <div
                    className="dropdown-menu drop-down-themed"
                    style={{ width: 'auto' }}
                    aria-labelledby="dropdownMenuButton">
                    <div
                        className="dropdown-item rounded-0 drop-down-item-no-transform"
                        onClick={() => {
                            sortDefault();
                        }}>
                        <a>
                            <span style={getOptionStyle(SORT_TYPES.DEFAULT)}>
                                Default
                            </span>
                        </a>
                    </div>
                    <div
                        className="dropdown-item rounded-0 drop-down-item-no-transform"
                        onClick={() => {
                            sortPositional();
                        }}>
                        <a>
                            <span style={getOptionStyle(SORT_TYPES.POSITIONAL)}>
                                Positional
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {CommentSorter};